(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const {
  useState,
  useEffect,
  useRef
} = React;
setGlobal('svs.ticketgames.ticketUtility.components.TopBar', _ref => {
  let {
    onClose,
    isSoundOn,
    onSoundClick,
    trackingLabel
  } = _ref;
  const {
    TopBarOverlay
  } = svs.ticketgames.ticketUtility.components;
  const {
    ticketInfo
  } = svs.ticketgames.ticketUtility.components.useGameContext();
  const [guides, setGuides] = useState([]);
  const mounted = useRef(false);
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false);
  const {
    showDialog
  } = svs.ticketgames.ticketUtility.utils;
  const {
    hasSound
  } = ticketInfo;
  const {
    fetchGuides
  } = svs.ticketgames.ticketUtility.utils;
  const {
    trackTopBarAction
  } = svs.ticketgames.ticketUtility.utils.tracking;
  useEffect(() => {
    mounted.current = true;
    (async () => {
      const guides = await fetchGuides(ticketInfo);
      mounted.current && setGuides(guides);
    })();
    return () => {
      mounted.current = false;
    };
  }, [ticketInfo]);
  const activeTabIndex = shouldShowOverlay ? -1 : 0;
  return React.createElement("div", {
    className: "bg-navy padding-1 gamelauncher-topbar"
  }, React.createElement(TopBarOverlay, {
    guides: guides,
    isActive: shouldShowOverlay,
    onCloseOverlay: () => {
      setShouldShowOverlay(false);
    },
    trackingLabel: trackingLabel
  }), React.createElement("div", null, React.createElement("a", {
    className: "fc-white ts-top-bar-menu-item margin-right-2 u-text-decoration-underline js-pause24-trigger",
    href: "",
    onClick: () => {
      trackTopBarAction('Spelpaus24', trackingLabel);
    },
    tabIndex: activeTabIndex
  }, "Spelpaus24"), React.createElement("a", {
    className: "fc-white ts-top-bar-menu-item u-text-decoration-underline",
    href: "",
    onClick: e => {
      e.preventDefault();
      showDialog({
        type: 'selfTest',
        onClose
      });
      trackTopBarAction('Självtest', trackingLabel);
    },
    tabIndex: activeTabIndex
  }, "Sj\xE4lvtest")), React.createElement("div", null, hasSound && React.createElement("a", {
    className: "margin-right-2",
    "data-testid": "sound-top-bar",
    href: "",
    onClick: e => {
      e.preventDefault();
      onSoundClick();
      trackTopBarAction(isSoundOn ? 'Ljud_av' : 'Ljud_på', trackingLabel);
    },
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: isSoundOn ? 'sound-on' : 'sound-off'
  })), guides.length > 0 && React.createElement("a", {
    className: "margin-right-2",
    "data-testid": "info-top-bar",
    href: "",
    onClick: e => {
      e.preventDefault();
      trackTopBarAction('Info', trackingLabel);
      setShouldShowOverlay(true);
    },
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "information"
  })), onClose && React.createElement("a", {
    "data-testid": "close-top-bar",
    href: "",
    onClick: e => {
      e.preventDefault();
      trackTopBarAction('Stäng', trackingLabel);
      onClose();
    },
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "close"
  }))));
});

 })(window);